import { render, staticRenderFns } from "./DiscoverComponent.vue?vue&type=template&id=4524ea12&scoped=true"
import script from "./DiscoverComponent.vue?vue&type=script&lang=js"
export * from "./DiscoverComponent.vue?vue&type=script&lang=js"
import style0 from "./DiscoverComponent.vue?vue&type=style&index=0&id=4524ea12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4524ea12",
  null
  
)

export default component.exports